import { Component, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ToastsManager } from "ng2-toastr";
import { Observable } from "rxjs";
import { IPagedResults } from "../../../core/interfaces";
import { Type4Service } from "../../../services";
import { modalLarge } from "../../../shared/modules/dialogOptions";
import { Type4EditFormComponent } from "../edit-form/type4-edit-form.component";

@Component({
    selector: 'app-type4-list',
    templateUrl: './type4-list.component.html',
    styleUrls: ['./type4-list.component.scss', '../../layout/layout.component.scss']
})
export class Type4ListComponent {
    public showSpinner: boolean = false;
    public itemPerPage: number = 10;
    public currentPage: number = 1;
    public totalItems: number = 10;
    public isAdminOrUserEditor = false;
    public isSuperAdmin = false;
    public isPreviewOn: boolean = false;

    deleteId: any;
    modalReference: NgbModalRef;
    packageData: any;

    @Output()
    DeletedType = new EventEmitter<any>();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private modalService: NgbModal,
        private type4Service: Type4Service
    ) {

    }

    ngOnInit() {
        if (this.isSuperAdmin) {
            this.loadData();
        }
    }

    loadData(page?: number, id?: number) {
        this.showSpinner = true;
        let filter = '';
        if (page != null) {
            this.currentPage = page;
        }
        var user = JSON.parse(localStorage.getItem('currentUser'));
        var SiteId = +localStorage.getItem('currentSiteId');
        this.type4Service.getAllType4(user.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData = (response.Data);
                this.totalItems = response.Data.length;
                // this.toastr.success(response.Message, "Success"); 
            });
    }

    loadDataById(id: number) {
        this.showSpinner = true;
        let filter = '';
        var user = JSON.parse(localStorage.getItem('currentUser'));
        var SiteId = +localStorage.getItem('currentSiteId');
        this.type4Service.getAllType4(user.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData = (response.Data);

                this.totalItems = response.Data.length;
            });
    }

    editType(id: number) {
        const modalRef = this.modalService.open(Type4EditFormComponent, modalLarge);
        modalRef.componentInstance.modalIdData = id;
        modalRef.result.then((result) => {
            this.ngOnInit();
            //alert(result);
            this.loadDataById(result);
        }, (reason) => {
            this.ngOnInit();
            // alert(reason +"aaa");
        });
    }

    openLg(content, id) {
        this.deleteId = id;
        this.modalReference = this.modalService.open(content);
    }

    deletType(id: number) {
        this.type4Service.deleteType4(id).catch((err: any) => {
            return Observable.throw(err);
        })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Success) {
                    this.toastr.success(response.Message, "Success");
                } else {
                    this.toastr.error(response.Message, "Cannot delete");
                }
                this.modalReference.close();
                // this.ngOnInit();
                this.DeletedType.emit({ GuardId: id });
            });
    }

    editCustomType() {
        throw new Error("not Implemented"); // todo: not implemented
    }

    public toggleIsActive(id: number, name: string) {
        this.type4Service.toggleIsActive(id).subscribe((res: any) => {
            this.toastr.success(`${name} was ${(res ? "enabled" : "disabled")} successfully`, "Success");
            this.loadData()
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/components/type4/list/type4-list.component.ts